import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import { CompareProvider } from "@/context/CompareContext";
import { FavoritesProvider } from "@/context/FavoritesContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CompareDrawer from "@/components/CompareDrawer";
import WhatsAppFab from "@/components/WhatsAppFab";

import Home from "@/pages/Home";
import Listings from "@/pages/Listings";
import ProjectDetail from "@/pages/ProjectDetail";
import Compare from "@/pages/Compare";
import EmiCalculator from "@/pages/EmiCalculator";
import PostProperty from "@/pages/PostProperty";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import MyDashboard from "@/pages/MyDashboard";
import CityPage from "@/pages/CityPage";
import About from "@/pages/About";
import Favorites from "@/pages/Favorites";
import AdminInquiries from "@/pages/AdminInquiries";
import AdminProjects from "@/pages/AdminProjects";
import AdminProjectEdit from "@/pages/AdminProjectEdit";
import NriServices from "@/pages/NriServices";
import HomeLoans from "@/pages/HomeLoans";
import InteriorWorks from "@/pages/InteriorWorks";
import HotDeals from "@/pages/HotDeals";
import PropertyInsights from "@/pages/PropertyInsights";
import Valuation from "@/pages/Valuation";
import VastuCalculator from "@/pages/VastuCalculator";
import PrivacyPolicy from "@/pages/PrivacyPolicy";

function App() {
  return (
    <div className="App grain-overlay min-h-screen bg-[#F8F9FA] text-slate-900">
      <AuthProvider>
        <FavoritesProvider>
          <CompareProvider>
            <BrowserRouter>
              <Navbar />
              <main>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/projects" element={<Listings />} />
                  <Route path="/projects/:id" element={<ProjectDetail />} />
                  <Route path="/compare" element={<Compare />} />
                  <Route path="/emi-calculator" element={<EmiCalculator />} />
                  <Route path="/post-property" element={<PostProperty />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/dashboard" element={<MyDashboard />} />
                  <Route path="/favorites" element={<Favorites />} />
                  <Route path="/admin/inquiries" element={<AdminInquiries />} />
                  <Route path="/admin/projects" element={<AdminProjects />} />
                  <Route path="/admin/projects/:id/edit" element={<AdminProjectEdit />} />
                  <Route path="/city/:city" element={<CityPage />} />
                  <Route path="/nri-services" element={<NriServices />} />
                  <Route path="/home-loans" element={<HomeLoans />} />
                  <Route path="/interior-works" element={<InteriorWorks />} />
                  <Route path="/hot-deals" element={<HotDeals />} />
                  <Route path="/insights" element={<PropertyInsights />} />
                  <Route path="/valuation" element={<Valuation />} />
                  <Route path="/vastu" element={<VastuCalculator />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                  <Route path="/about" element={<About />} />
                </Routes>
              </main>
              <Footer />
              <CompareDrawer />
              <WhatsAppFab />
            </BrowserRouter>
            <Toaster position="top-right" richColors theme="light" />
          </CompareProvider>
        </FavoritesProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
